<!--
 * @Description: 创建班级
 * @Author: xiawenlong
 * @Date: 2021-04-26 10:03:44
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-06-14 12:28:30
-->
<template>
  <div class="class-add">
    <el-card>
      <div slot="header" class="clearfix">
        <span class="title">{{ classId ? '修改班级' : '创建班级' }}</span>
      </div>
      <el-form ref="form" :model="form" label-width="115px" :rules="rules">
        <el-form-item label="班级名称" prop="className">
          <el-input v-model="form.className" placeholder="请输入班级名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="班主任" required>
          <ul v-if="teachers.length" class="teachers">
            <li v-for="(item, index) in teachers" :key="item.headTeacherId" class="teacher">
              <span>{{ item.headTeacherName }}</span>
              <img
                src="@/assets/common/close_icon.png"
                class="close"
                @click="removeTeacher(item, index)"
              />
            </li>
          </ul>
          <el-button v-if="teachers.length < 3" @click="selectAdviser">请选择班主任</el-button>
        </el-form-item>
        <!-- <el-form-item label="班级人数" prop="classSize">
          <el-input
            v-model="form.classSize"
            placeholder="请设置班级报名人数上限"
            clearable
          ></el-input
          >人
        </el-form-item> -->
        <el-form-item label="培训时间" prop="classTime">
          <el-date-picker
            v-model="form.classTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="{
              disabledDate: time => {
                return time.getTime() < Date.now() - 3600 * 1000 * 24
              },
            }"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item ref="pic" label="封面图片" prop="pic">
          <upload-image
            v-model="form.pic"
            :upload-img="$refs.pic"
            :width-size="widthSize"
            :height-size="heightSize"
          ></upload-image>
          <p class="tip">图片大小最好在564 X 290，支持扩展名：.png .jpg .jpeg</p>
        </el-form-item>
        <el-form-item label="班级介绍:" prop="introduction">
          <el-input
            v-model="form.introduction"
            type="textarea"
            :rows="5"
            placeholder="请输入至少五个字符"
            class="introduction"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="submit">
            {{ classId ? '确定修改' : '确定添加' }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <class-adviser-dialog
      ref="classAdviserDialog"
      @handleTeachersChange="handleTeachersChange"
    ></class-adviser-dialog>
  </div>
</template>
<script>
import { classCreate, classUpdate, classInfo } from '@/api/class'
import to from 'await-to'
import UploadImage from '@/components/UploadImage'
import ClassAdviserDialog from '@/views/course/components/ClassAdviserDialog'
export default {
  name: 'ClassAdd',
  components: { UploadImage, ClassAdviserDialog },
  data() {
    return {
      widthSize: 564,
      heightSize: 290,
      rules: {
        className: [
          { required: true, message: '请输入班级名称', trigger: 'blur' },
          { min: 3, max: 12, message: '请输入4~12个字', trigger: 'blur' },
        ],
        classSize: [{ required: true, message: '请输入班级人数上限', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传课程封面图', trigger: 'change' }],
        introduction: [
          { required: true, message: '请至少输入5个字符', trigger: 'blur' },
          { min: 5, message: '请至少输入5个字符', trigger: 'blur' },
        ],
        classTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
      },
      form: {},
      loading: false,
      teachers: [],
      classId: '',
    }
  },
  mounted() {
    this.classId = this.$route.query.classId
    if (this.classId) this.getClassInfo()
  },
  methods: {
    async getClassInfo() {
      const [res, err] = await to(classInfo({ classId: this.classId }))
      if (err) return this.$message.warning(err.msg)
      this.form = { ...res.data, classTime: [res.data.classBeginTime, res.data.classEndTime] }
      this.teachers = this.form.headTeacherList
    },
    selectAdviser() {
      this.$refs.classAdviserDialog.show(this.teachers)
    },
    handleTeachersChange(val) {
      this.teachers = val
    },
    removeTeacher(item, index) {
      this.teachers.splice(index, 1)
    },
    submit() {
      this.classId ? this.update() : this.create()
    },
    create() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loading = true
          const [, err] = await to(
            classCreate({
              ...this.form,
              classBeginTime: this.form.classTime[0],
              classEndTime: this.form.classTime[1],
              headTeacherIds: this.teachers.map(item => item.headTeacherId),
            }),
          )
          this.loading = false
          if (err) return this.$message.warning(err.msg)
          this.$message.success('创建成功')
          this.$router.push('/course/class')
        }
      })
    },
    update() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loading = true
          const [, err] = await to(
            classUpdate({
              ...this.form,
              classId: this.classId,
              classBeginTime: this.form.classTime[0],
              classEndTime: this.form.classTime[1],
              headTeacherIds: this.teachers.map(item => item.headTeacherId),
            }),
          )
          this.loading = false
          if (err) return this.$message.warning(err.msg)
          this.$message.success('修改成功')
          this.$router.push('/course/class')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.class-add {
  .el-radio-button {
    margin-bottom: 20px;
  }
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  ::v-deep .uploader {
    height: 92px;
    .el-upload {
      width: 180px;
      height: 100%;
      background: #f5f5f5;
      border-radius: 5px;
    }
    .el-upload-list__item {
      width: 180px;
      height: 100%;
    }
  }
  ::v-deep .el-upload-dragger {
    background: #f5f5f5;
  }
  .teachers {
    li {
      box-sizing: border-box;
      float: left;
      position: relative;
      cursor: pointer;
      min-width: 80px;
      padding: 0 13px;
      height: 40px;
      opacity: 1;
      background: #ffffff;
      border: 1px solid #d5d5d5;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      color: #333333;
      margin-right: 25px;
      margin-bottom: 10px;
      .close {
        position: absolute;
        width: 14px;
        height: 14px;
        right: -5px;
        top: -5px;
      }
    }
  }
  .introduction {
    width: 600px;
    height: 118px;
  }
}
</style>
